import {Injectable} from '@angular/core';
import {ApiService} from '~/app/core/common/services/api.service';
import {BaseService} from '~/app/core/common/services/base.service';
import { HttpClient } from '@angular/common/http';
import {InventoryReceiving} from '~/app/core/common/models/inventoryReceiving';
import {InventoryDetails} from '~/app/core/common/models/inventoryDetails';
import {GoogleAnalyticsService} from '~/app/core/common/services/google-analytics.service';
import {ApplicationSettingsHelper} from '~/app/shared/helpers/application-settings-helper';
import {InternetConnectionService} from '~/app/shared/services/internet-connection.service';
import {ErrorApiService} from '~/app/core/common/test/error-api.service';


@Injectable({
    providedIn: 'root'
})
export class InventoryService extends BaseService {

    public inventoryItemSelected: InventoryDetails[] = [];
    public adjustments: number;
    public compTotal: number;
    public compDiff: number;
    public bohReceipt: any;
    public ftpReceipt: any;
    private _inventoryDetails: InventoryReceiving;
    private _selectedItem: InventoryDetails;
    private _processing = false;

    constructor(public apiService: ApiService,
                public http: HttpClient,
                public googleAnalyticsService: GoogleAnalyticsService,
                public internetConnectionService: InternetConnectionService,
                public errorApiService: ErrorApiService,
                public applicationSettingsHelper: ApplicationSettingsHelper,
    ) {
        super(http,
            googleAnalyticsService,
            internetConnectionService,
            errorApiService,
            applicationSettingsHelper);
    }

    get inventoryDetails(): InventoryReceiving {
        return this._inventoryDetails;
    }

    set inventoryDetails(value: InventoryReceiving) {
        this._inventoryDetails = value;
    }

    get selectedItem(): InventoryDetails {
        return this._selectedItem;
    }

    set selectedItem(value: InventoryDetails) {
        this._selectedItem = value;
    }

    get processing(): boolean {
        return this._processing;
    }

    set processing(value: boolean) {
        this._processing = value;
    }

    async getInventoryReceivingDetails(customerId: number, status: number, trackingId: number) {
        const inventoryURL = this.apiService.inventoryGetDetailsURL
            .replace('customerId', customerId.toString())
            .replace('current_status', status.toString())
            .replace('tracking_Id', trackingId.toString());
        this.inventoryDetails = await this.getHttp(
            'getInventoryReceivingDetails',
            'inventory-service', inventoryURL)
            .toPromise()
            .then((results) => {
                return results as InventoryReceiving;
            });
        this.selectedItem = this.inventoryDetails.details[0];
        this.inventoryDetails.details.forEach((item) => {
            item.amount = +(item.price * item.qty).toFixed(2);
            item.uomPackSize = item.purchaseUOM + '-' + item.packSize + item.packUOM;
            item.hasError = false;
        });
        this.updateHeaderData();

    }

    async getBohReceipt(customerId: number, trackingId: number) {
        const bohReceiptURL = this.apiService.downloadBohReceipt
            .replace('customerId', customerId.toString())
            .replace('tracking_Id', trackingId.toString());

        this.bohReceipt = await this.http.get(bohReceiptURL, {responseType: 'text'})
            .toPromise()
            .then((results) => results);
    }

    async getFtpReceipt(customerId: number, trackingId: number) {
        const ftpReceiptURL = this.apiService.downloadFtpReceipt
            .replace('customerId', customerId.toString())
            .replace('tracking_Id', trackingId.toString());

        this.ftpReceipt = await this.http.get(ftpReceiptURL, {responseType: 'text'})
            .toPromise()
            .then((results) => results);
    }

    replacer(key: any, value: any) {
        if (key === 'amount' || key === 'hasError' || key === 'uomPackSize') {
            return undefined;
        } else {
            return value;
        }
    }

    async saveInventoryReceipt(inventoryReceiving: InventoryReceiving) {
        const saveReceiptUrl = this.apiService.saveReceivingReceipt;
        const receipt = JSON.stringify(inventoryReceiving, this.replacer);
        await this.postHttpJson('saveInventoryReceipt',
            'inventory-service', saveReceiptUrl, receipt).toPromise().then((callResult) => {
            return callResult;
        });
    }

    updateHeaderData() {
        this.adjustments = (parseFloat(this.inventoryDetails.header.salesTax.toString()) +
            parseFloat(this.inventoryDetails.header.surcharge.toString()) -
            parseFloat(this.inventoryDetails.header.discount.toString()));
        this.compTotal = +this.inventoryDetails.details.reduce((acc, item) => acc + item.amount, 0).toFixed(2);
        console.log('Receipt Total: ' + this.inventoryDetails.header.receiptTotal + ' Adjustments: ' + this.adjustments + ' Comp Total: ' + this.compTotal);
        this.compDiff = +(this.inventoryDetails.header.receiptTotal - this.adjustments - this.compTotal).toFixed(2);
        console.log('CompDiff: ' + this.compDiff);
    }

    updateItemData(invDetails: InventoryDetails) {
        this.inventoryDetails.details.map((value) => {
            if (value.customerItem === invDetails.customerItem) {
                value.qty = +invDetails.qty;
                value.amount = value.qty * value.price;
            }
        });
    }

    onDeleteItem() {
        const selectedIndex = this.inventoryDetails.details.indexOf(this.selectedItem);
        this.inventoryDetails.details.splice(selectedIndex, 1);
        this.updateHeaderData();
    }

}
